<script setup lang="ts">
import type { TAccordion } from './index.vue';

const props = withDefaults(
  defineProps<{ allowMultipleOpen?: boolean, defaultOpenFirst?: boolean }>(),
  { defaultOpenFirst: true }
);
const accordionsList = ref<TAccordion[]>([]);

provide('accordion-group', { registerAccordion, closeAllAccordions });

function registerAccordion(accordion: TAccordion) {
  accordionsList.value.push(accordion);
};
function closeAllAccordions() {
  if (props.allowMultipleOpen) return;
  accordionsList.value.forEach(accordion => accordion.closeAccordion());
};

onMounted(() => {
  if (props.defaultOpenFirst) accordionsList.value[0]?.openAccordion();
});
</script>

<template>
  <slot />
</template>